// extracted by mini-css-extract-plugin
export default {"item":"BurgerMenuItem-module--item--CVZjK","icon":"BurgerMenuItem-module--icon--sU2Au","right":"BurgerMenuItem-module--right--72r+5"};